var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitScreenElementRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 430,
    viewBox: "0 0 179 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.15 234.261C233.375 218.607 272.443 172.712 271.59 118.758C270.557 53.2925 209.92 0.339235 136.84 1.00626C63.7955 1.66252 4.80301 54.9062 4.80301 120.501C4.80301 149.538 15.1795 177.09 35.5963 196.864C90.1451 249.721 265.826 397.79 265.826 397.79C278.868 409.172 269.873 429 251.654 429L-0.000959023 429",
    stroke: "url(#paint0_linear_407_8)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_407_8",
    x1: 125.087,
    y1: 429,
    x2: 121.893,
    y2: 1.00002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BA6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitScreenElementRight);
export default __webpack_public_path__ + "static/media/exitScreenElementRight.62bf295b1d87a8fa8d8f65bf90f2ac78.svg";
export { ForwardRef as ReactComponent };